import {
    Component
} from "../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-black-join.scss";
import {Network} from "../../../../../../network/Network";
import {Resources} from "../../../../../../resources/Resources";
import {WebsiteBlackReviewComponent} from "../review/WebsiteBlackReviewComponent";
import {WebsiteBlackUnionLineComponent} from "../union/line/WebsiteBlackUnionLineComponent";

export class WebsiteBlackJoinComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackJoin}">
                <div class="${s.names}">
                    <div class="${s.titles}">
                        <h2>
                            ${Resources.t("words.ninetySevenPercentNoTraffic")}
                        </h2>
                        <h3>${Resources.t("words.joinThreePercentWithSedestral")}</h3>
                    </div>
                </div>
                ${this.draw(new WebsiteBlackUnionLineComponent())}
                <div>
                    ${this.draw(new WebsiteBlackReviewComponent({
                        link: Network.router.pages.getUrlWithPath('testimonial/bet-thermique'),
                        linkText: Resources.t("words.readFullTestimonial"),
                        name: "Vincent Coralie",
                        role: Resources.t("words.ceoBetThermique"),
                        review: Resources.t("words.vincentReview"),
                        stats: [
                            {value: "+483%", label: "clics en 6 mois"},
                            {value: "+52%", label: "impressions en 6 mois"}
                        ]
                    }))}
                </div>
                <a href="${Network.router.pages.getPanelUrl('signup')}" target="_blank" class="${s.start}">
                    <div class="${s.startShadow}"></div>
                    <div class="${s.content}">
                        ${Resources.t("words.beginFree")}
                        <div class="${s.icon}"></div>
                    </div>
                </a>
            </div>
        `;
    }
}